import React from 'react';
import DocumentPage from '../DocumentPage';

import DocumentFooter from '../DocumentFooter';
import DocumentHeading from '../DocumentHeading';

interface Props extends React.PropsWithChildren {
  headerContent?: {
    title: string;
    photo?: string;
    infos?: { name: string; value: string }[];
  };
  header?: React.ReactNode;
  footer?: React.ReactNode;
  wrap?: boolean;
  debug?: boolean;
}

const DocumentLayout: React.FC<Props> = ({
  children,
  headerContent,
  header,
  footer,
  wrap = true,
  debug = false,
}) => {
  const DocumentHeader = React.useMemo(() => {
    if (header) {
      return header;
    }

    if (headerContent) {
      const { title, photo, infos } = headerContent;

      return <DocumentHeading title={title} photo={photo} infos={infos} />;
    }

    return null;
  }, [header, headerContent]);

  return (
    <DocumentPage wrap={wrap} debug={debug}>
      {DocumentHeader}

      {children}

      <DocumentFooter>{footer}</DocumentFooter>
    </DocumentPage>
  );
};

export default DocumentLayout;
